import results from './results';
import searches from './searches';
import bookings from './bookings';

export default {
  results,
  searches,
  bookings
}